module.exports = __webpack_public_path__ + "static/media/arrow-line-left-light.07c7e815.svg";